import React, { useEffect, useState } from "react";
import '../HomePage/HomeInsurance.css';
import { CityStateByPinCode } from "../CommonMethods/CityStateByPinCode";
import { apiURL } from "../index";
import axios from "axios";
import OtherLink from "../HomePage/OtherLink";
import { FilterData } from "./FilterData";
import MaskedInput from "react-text-mask";
import { CommaSeprator, convertIntoLakh } from "./UtilityComponents/UilityFunctions";
import { useSharedDataContext } from "../components/SharedDataContext";

const FormArea = ({ BtnValue, term, TandC,  onSubmitDetails }) => {

    const [isActive, setIsActive] = useState(false);
    const [isAreaRate, setIsAreaRate] = useState(false);
    const [isAreaUnit, setIsAreaUnit] = useState(false);
    const [Errors, setErrors] = useState({});
    const [showFirstForm, setShowFirstForm] = useState(true);
    const [isValid, setValid] = useState(false);
    const [touchedFields, setTouchedFields] = useState({});
    const [homeDetailsObj, setHomeDetailsObj] = useState({
        property: "BUILDING",
        insure: "Owned",
        pincode: "",
        mobileNo: "",
        valueOfBuilding: "",
        areaOfBuilding: "",
        valueOfHouseHoldItem: "",
        location: "",
        occupancy: [],
        occupancyID: "",
        companyId:"124"
    });

    const { sharedData, setSharedData } = useSharedDataContext();

    useEffect(() => {
        async function fetchPinCodeDetails() {
            if (homeDetailsObj.pincode?.length === 6) {
                try {
                    const { data } = await CityStateByPinCode(homeDetailsObj.pincode);
                    if (data.statusCode === 200) {
                        setHomeDetailsObj({ ...homeDetailsObj, location: `${data.response.cityName}, ${data.response.stateName}` });
                        //setErrors(prev => ({ ...prev, PinCode: "" }));
                    }
                } catch (error) {
                    console.error("Error fetching pin code details:", error);
                }
            } else {
                setHomeDetailsObj({ ...homeDetailsObj, location: "" });
            }
        }
        fetchPinCodeDetails();
    }, [homeDetailsObj.pincode]);


    useEffect(() => {
        const validationForm = () => {
            let error = {};
            let goto = true;
            const { pincode, mobileNo, property, valueOfBuilding, valueOfHouseHoldItem } = homeDetailsObj;
            if (showFirstForm) {
                if (touchedFields.mobileNo) {

                // Validate mobile number
                if (mobileNo === "") {
                    error["MobileNo"] = "Please enter a mobile number";
                    goto = false;
                } else if (mobileNo.length !== 10) {
                    error["MobileNo"] = "Please enter a 10-digit number";
                    goto = false;
                } else if (["6666666666", "7777777777", "8888888888", "9999999999"].includes(mobileNo)) {
                    error["MobileNo"] = "Please enter a valid mobile number";
                    goto = false;
                } else {
                    error["MobileNo"] = ""; // Clear the error if valid
                    }
                }

                if (touchedFields.pincode) {
                    // Validate pin code
                    if (pincode === "") {
                        error["PinCode"] = "Please enter a Pin Code";
                        goto = false;
                    } else if (pincode.length !== 6) {
                        error["PinCode"] = "Please enter a valid pin code";
                        goto = false;
                    } else {
                        error["PinCode"] = ""; // Clear the error if valid
                    }
                }

            }
            else {
                if (property) {
                    var propertyUpperCase = property.toUpperCase();

                    if (propertyUpperCase === "BUILDING") {
                        if (!valueOfBuilding || parseInt(valueOfBuilding ?? "0") < 500000 || parseInt(valueOfBuilding ?? "0") > 1000000000) {
                            error["valueOfBuilding"] = "Please enter value between 5 lakhs to 100 crores";
                            goto = false;
                        } else {
                            error["valueOfBuilding"] = "";
                        }
                    }
                    else if (propertyUpperCase === "HOUSEHOLD") {
                        if (!valueOfHouseHoldItem || parseInt(valueOfHouseHoldItem ?? "0") < 100000 || parseInt(valueOfHouseHoldItem ?? "0") > 500000000) {
                            error["property"] = "Please enter a value between 1 lakhs to 50 crores";
                            goto = false;
                        } else {
                            error["property"] = "";
                        }
                    }
                    else if (propertyUpperCase === "BOTH") {
                        if (!valueOfHouseHoldItem || parseInt(valueOfHouseHoldItem ?? "0") < 100000 || parseInt(valueOfHouseHoldItem ?? "0") > 500000000) {
                            error["valueOfHouseHoldItem"] = "Please enter a value between 1 lakhs to 50 crores";
                            goto = false;
                        } else {
                            error["valueOfHouseHoldItem"] = "";
                        }
                        if (!valueOfBuilding || parseInt(valueOfBuilding ?? "0") < 500000 || parseInt(valueOfBuilding ?? "0") > 1000000000) {
                            error["valueOfBuilding"] = "Please enter a value between 5 lakhs to 100 crores";
                            goto = false;
                        } else {
                            error["valueOfBuilding"] = "";
                        }
                    }
                }

            }
            setValid(goto);
            setErrors(error); // Update error state
        };
        validationForm();
        }, [homeDetailsObj.mobileNo, homeDetailsObj.pincode, homeDetailsObj.property, homeDetailsObj.valueOfBuilding, homeDetailsObj.valueOfHouseHoldItem]);



    const SubmitForm = (step) => {
        if (step === 1 && isValid) {
            setShowFirstForm(false);
        }

        if (!showFirstForm && isValid) {

            setSharedData({ ...sharedData, homeDetailsObj });

            onSubmitDetails(homeDetailsObj);
        }

        
    }

    useEffect(() => {
        Occupacy();        
    }, []);

    const Occupacy = async () => {
        let OccupayReq = {
            companyId: homeDetailsObj.companyId
        }
        try {
            let { data: Res } = await axios.post(`${apiURL}api/Central/GetOccupationDeatils`, OccupayReq);
            if (Res.statusCode === 200) {
                setHomeDetailsObj(prev => ({...prev, occupancy: Res.response  }));
                //setOccupancy(prev => ({ ...prev, occupancy: Res.response }));
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setHomeDetailsObj({ ...homeDetailsObj, [name]: (name == "areaOfBuilding" || name == "valueOfBuilding") ? value.replace(/[^\d]/g, '') : value });
        setTouchedFields((prev) => ({ ...prev, [name]: true }));
    }

    return (
        <>

            {showFirstForm ? (
                <div className="Lowest_Rate">
                    <form className="form_detail" onSubmit={(e) => { e.preventDefault(); SubmitForm(1); }}>
                        <h5 className="form_heading mb-0">Please Enter Your Details</h5>
                        <div className="my-4">
                            <span className="property_type">Property Type</span>
                            <span className="property_type">
                                <input
                                    type="radio"
                                    value="Owned"
                                    name="insure"
                                    className=""
                                    onChange={handleChange}
                                    checked={homeDetailsObj.insure === "Owned"} />
                                Owned</span>
                            <span className="property_type">
                                <input
                                    type="radio"
                                    value="Rented"
                                    name="insure"
                                    className=""
                                    onChange={handleChange}
                                    checked={homeDetailsObj.insure === "Rented"} />
                                Rented</span>
                        </div>

                        <div className="user_detail">
                            <MaskedInput
                                mask={[
                                    /[1-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                className=""
                                type="text"
                                name="pincode"
                                placeholder=""
                                value={homeDetailsObj.pincode}
                                maxLength="6"
                                onChange={handleChange}
                                required

                            />
                            <label htmlFor="text">PIN Code</label>
                            <span className="city_stateName">{homeDetailsObj.location}</span>
                            <span className="error_msg">{Errors["PinCode"]}</span>
                        </div>
                        <div className="user_detail">
                            <span className="countryCodeStyle">
                                {isActive || homeDetailsObj.mobileNo ? '+91' : ''}
                            </span>

                            <MaskedInput
                                mask={[
                                    /[6-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                type="text"
                                name="mobileNo"
                                placeholder=""
                                value={homeDetailsObj.mobileNo}
                                maxLength="10"
                                onChange={handleChange}
                                required
                                className="animatedInput2"
                                onBlur={() => setIsActive(false)}
                                onFocus={() => setIsActive(true)}
                            />
                            <label htmlFor="number">Mobile Number</label>
                            <span className="error_msg">{Errors["MobileNo"]}</span>
                        </div>
                        <div className="view_quotes">
                            <button
                                disabled={!homeDetailsObj.mobileNo || !homeDetailsObj.pincode}
                                type="submit"
                                className="FormGetTouch"
                            > Continue </button>
                        </div>
                    </form>
                </div>
            ) : (
                <div className="Lowest_Rate">
                    <form className="form_detail" onSubmit={(e) => { e.preventDefault(); SubmitForm(2); }}>
                        <h5 className="form_heading mb-0">Please Enter Your Building Details</h5>
                        <div className="form_userDetail my-3" onClick={() => setShowFirstForm(true)}>
                            <span>
                                <i className="fa fa-arrow-left"></i>
                            </span>
                            <span>Property Type: {homeDetailsObj.insure}, </span>
                            <span>Mobile No.: {homeDetailsObj.mobileNo}, </span>
                            <span>Pin Code: {homeDetailsObj.pincode}</span>
                        </div>
                        <div className="mb-3 property_hidden">
                            <p className="property_type mb-2">Please Enter Your Building Details</p>
                            <span className="property_type">
                                <input
                                    type="radio"
                                    value="BUILDING"
                                    name="property"
                                    className="Property_TypeBuilding"
                                    onChange={handleChange}
                                    checked={homeDetailsObj.property === "BUILDING"}
                                />
                            </span>
                            <small className="error_msg">{Errors?.valueOfBuilding}</small>
                        </div>
                        <div className="user-input-wrp select_drp my-4">
                            <span className="DropDown_label">Occupancy</span>
                            <FilterData
                                ArrayList={homeDetailsObj?.occupancy ??[]}
                                FilterKey={"codeOfOccupation"}
                                onSelect={(data) => setHomeDetailsObj(prev => ({ ...prev, occupancyID: data }))}
                                DefaultTitle={homeDetailsObj.occupancyID?.id ? homeDetailsObj.occupancyID?.descriptionOfOccupancy : "Select Occupancy"}
                                ListNameKey={"descriptionOfOccupancy"}
                            />
                                <span className="error_msg">{Errors["MobileNo"]}</span>
                        </div>

                        {homeDetailsObj.property === "BUILDING" &&
                            <div>
                                <div className="user_detail">
                                    <span className="countryCodeStyle">
                                        {isAreaRate || homeDetailsObj?.valueOfBuilding ? '₹' : ''}
                                    </span>
                                    <input
                                        type="text"
                                        name="valueOfBuilding"
                                        value={CommaSeprator(homeDetailsObj?.valueOfBuilding)}
                                            onChange={(e) => {
                                                const value = parseInt(e.target.value.replace(/,/g, "")); // Remove commas before validation
                                                if (isNaN(value) || value <= 1000000000) { // Allow value if it's a number and <= 100 crores
                                                    handleChange(e); // Call the change handler if the value is valid
                                                }
                                            }}
                                            className="animatedInput3"
                                           // maxLength={10}
                                        required
                                        onBlur={() => setIsAreaRate(false)}
                                        onFocus={() => setIsAreaRate(true)}
                                    />
                                    <label htmlFor="text">Value of building</label>
                                    <small className="error_msg">{Errors.valueOfBuilding}</small>
                                    <p className="convert_lakhBox">{convertIntoLakh(homeDetailsObj.valueOfBuilding)}</p>
                                </div>
                                <div className="user_detail">
                                    <input
                                        type="text"
                                        name="areaOfBuilding"
                                        value={homeDetailsObj.areaOfBuilding}
                                        onChange={handleChange}
                                        className="animatedInput1"
                                            required
                                            maxLength={10}
                                        onBlur={() => setIsAreaUnit(false)}
                                        onFocus={() => setIsAreaUnit(true)}
                                    />
                                    <span className="countryCodeStyle2  ">
                                            {isAreaUnit || homeDetailsObj.areaOfBuilding ? 'sq. ft' : ''}
                                    </span>
                                    <label htmlFor="text">Area of the building</label>
                                </div>
                                {homeDetailsObj.valueOfBuilding && homeDetailsObj.areaOfBuilding && <div className="rate_value">
                                    <div className="value_building">
                                        <span>Rate per sq. ft</span>
                                        <p className="value_build" >₹{CommaSeprator(Math.round(parseInt(homeDetailsObj.valueOfBuilding) / parseInt(homeDetailsObj.areaOfBuilding)))}</p>
                                    </div>
                                </div>
                                }
                            </div>}
                        <div className="view_quotes">
                            <button
                                disabled={!homeDetailsObj.occupancyID?.descriptionOfOccupancy || !homeDetailsObj.property || !homeDetailsObj.areaOfBuilding || !homeDetailsObj.valueOfBuilding}
                                type="submit"
                                className="FormGetTouch"
                            >{BtnValue} </button>
                        </div>
                    </form>
                    <div>
                        <p className="mt-1 term_tc">{term} <a href="https://www.smcinsurance.com/terms-of-use"><span className="green-text">{TandC}</span></a></p>
                    </div>
                </div>
            )}
            <div className="Lowest_Rate">
                <OtherLink />
            </div>
        </>
    );
}
export default FormArea;
